import * as React from 'react';
import { useDispatch } from 'react-redux';
import { scrollMobileContainer } from '~/utils/scrollTop';
import ConfirmPurchase from '~/components/Popups/Purchase/ConfirmPurchase';
import { useParams } from 'react-router-dom';
import { appActions } from '~/Store/appSlice';

export const PURCHASE_POPUP_CONTAINER = 'purchase-popup';

const ConfirmPurchaseContainer = () => {
    const { id } = useParams();
    const dispatch = useDispatch();

    React.useEffect(() => {
        scrollMobileContainer({ top: 0 });

        dispatch(appActions.hiddenMobileNavigate(true));
        dispatch(
            appActions.changeCurrentPage({
                name: PURCHASE_POPUP_CONTAINER,
                isBundlePage: false,
            }),
        );

        return () => {
            dispatch(appActions.hiddenMobileNavigate(false));
        };
    }, []);

    return <ConfirmPurchase data={{ bundleId: Number(id) }} />;
};

export default ConfirmPurchaseContainer;
